 // worker.js

/* eslint-disable no-restricted-globals */ 
export default () => {

    self.addEventListener('message', event => { 
        const {imageFile,repeatTile,limit} = event.data;
        if(!imageFile){return;}
        let repeatX = Number(repeatTile.x);
        repeatX = isNaN(repeatX) ? 5 : repeatX;
        let repeatY = Number(repeatTile.y);
        repeatY = isNaN(repeatY) ? 5 : repeatY;
    
        createImageBitmap(imageFile).then(function(imageBitmap) {
            const w = imageBitmap.width;
            const h = imageBitmap.height;
            // console.log(imageBitmap)
    
            //clamp the resulting output to limit 10000
            let width = w*repeatX;
            let height = h*repeatY;
            let resizeWidth = w;
            let resizeHeight = h;
    
            // console.log(width,height)
            if( width > limit){
                resizeWidth = limit/repeatX;
                const ratio = resizeWidth/w;
                resizeHeight = resizeHeight *ratio;
                width = resizeWidth*repeatX;
                height = resizeHeight*repeatY;
            }
            if( height > 10000){
                resizeHeight = 10000/repeatY;
                const ratio = resizeHeight/h;
                resizeWidth = resizeWidth * ratio;
                width = resizeWidth*repeatX;
                height = resizeHeight*repeatY;
            }
    
            const offscreenCanvas = new OffscreenCanvas(width, height);
            const offscreenCtx = offscreenCanvas.getContext('2d');
            for(var x=0; x<=repeatX; x++){
                for(var y=0; y<=repeatY; y++){
                    offscreenCtx.drawImage(imageBitmap,x*resizeWidth,y*resizeHeight,resizeWidth,resizeHeight);
                }
            }
            offscreenCanvas.convertToBlob().then((blob)=>{
                // Post Message
                self.postMessage(blob);
            });
        });


      });

  }
